export default __webpack_public_path__ + "static/media/register.1e4196ab.jpg";